import { render, staticRenderFns } from "./LessonExplanation.vue?vue&type=template&id=9a518d48&scoped=true"
import script from "./LessonExplanation.vue?vue&type=script&lang=js"
export * from "./LessonExplanation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a518d48",
  null
  
)

export default component.exports